module.exports = __webpack_public_path__ + "media/team-ava-intro.8506107e.mp4";